{
  "auth": {
    "organisationChoice": {
      "title": "اختر منشأتك",
      "body": "بريدك الإلكتروني مسجّل لدى أكثر من منشأة. اختر المنشأة التي تريد فتحها.",
      "legend": "المنشآت",
      "continue": "متابعة",
      "required": "اختر منشأة للمتابعة",
      "back": "الدخول بحساب آخر",
      "continuingAs": "المتابعة باسم",
      "expiredTitle": "انتهت مهلة تسجيل الدخول",
      "expiredBody": "حفاظًا على أمانك يجب اختيار المنشأة خلال دقائق من إدخال كلمة المرور. سجّل الدخول مجدداً للمتابعة.",
      "signInAgain": "سجّل الدخول مجدداً"
    }
  },
  "mfa": {
    "security": {
      "unavailable": "تسجيل الدخول بخطوتين غير متاح في هذه البيئة."
    }
  }
}
